export default "__VITE_ASSET__DXx7_XN1__"